import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import React, { useMemo } from "react";
import { Button } from "@material-ui/core";

const VEBDataGrid = () => {
	const columnDefs = useMemo(
		() => [
			{ headerName: "Plan Name", field: "planName" },
			{ headerName: "Coverage", field: "coverage" },
			{ headerName: "Cost", field: "cost" },
			{ headerName: "Start Date", field: "startDate" },
			{ headerName: "End Date", field: "endDate" },
			{
				headerName: "Action",
				field: "action",
				cellRendererFramework: () => (
					<Button className="ag-grid-cell-button" variant="outlined">
						CheckThis
					</Button>
				)
			}
		],
		[]
	);

	const rowData = useMemo(
		() => [
			{
				planName: "Plan A",
				coverage: "Basic",
				cost: "$100",
				startDate: "2024-08-01",
				endDate: "2024-12-31",
				action: null // This will be rendered by the cellRendererFramework
			},
			{
				planName: "Plan B",
				coverage: "Premium",
				cost: "$200",
				startDate: "2024-09-01",
				endDate: "2024-12-31",
				action: null // This will be rendered by the cellRendererFramework
			}
		],
		[]
	);

	return (
		<div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
			<AgGridReact
				columnDefs={columnDefs}
				rowData={rowData}
				domLayout="autoHeight"
				defaultColDef={{
					resizable: true
				}}
			/>
		</div>
	);
};

export default VEBDataGrid;
